<template>
  <div>

    <div class="top" style="margin-top: 20px;">

      <div class="inner">
        <div class="picker">
          <picker />
        </div>
        <contrast style="margin-top: 40px"/>

      </div>

    
    </div>

   
  </div>
</template>

<script>
import Color from 'color';
import Picker from './components/picker/Picker.vue';
import RArticle from './components/Article.vue';
import Offer from './components/Offer.vue';
import RFooter from './components/Footer.vue';
import Logo from './components/Logo.vue';
import Contrast from './components/Contrast.vue';
import ColorSelectorMobile from './components/picker/ColorSelectorMobile.vue';
import ColorHelper from './tools/ColorHelper';

export default {
  components: {
    Picker, RArticle, Offer, RFooter, Logo, Contrast, ColorSelectorMobile
  },
  data() {
    return {
      mouse: {}
    };
  },
  beforeMount() {
    if (this.$route.name === 'StartCheck' && this.$route.params.colors) {
      let result = ColorHelper.parseUrlCheck(this.$route.params.colors)
      if (result === null) {
        this.$router.push('/')
      } else {
        this.$store.commit('setColor', { target: 'foreground', value: result[0], mode: 'rgb' })
        this.$store.commit('setColor', { target: 'background', value: result[1], mode: 'rgb' })
      }
    }
    
  
    // onsole.log('app got color', value)
    //     this.$store.commit('setColor', {
    //       target: this.target,
    //       value,
    //       mode: 'hex'
    //     })
    //   })
  },
  methods: {
    doThing() {
      let osPickerCallback = (e) => {
        console.log('os pickercallback!', e)
        this.mouse = e
      }

      // if (window.startOSPicker) {
      //   window.startOSPicker(osPickerCallback)
      // }
    }
  },
  computed: {
    topBack() {
      let hsl = Color(this.hex)
        .hsl()
        .array();
      let newC = Color.hsl([hsl[0], hsl[1], 95]);

      let r =
        'linear-gradient(-5deg, ' +
        newC.alpha(0).string() +
        ' 52%, ' +
        newC.alpha(0.1).string() +
        ' 53%, ' +
        newC.alpha(0.1).string() +
        ' 100%' +
        ')';
      return r;
    },
    hex() {
      return this.$store.getters.foreground.color.hex();
    },
    back() {
      return this.$store.getters.background.color.hex();
    },
    interfaceColor() {
      return this.$store.getters.interfaceColor.hex();
    }
  }
};
</script>

<style lang="scss">

</style>
